import * as firebase from "firebase/app";

import React, { Component } from "react";

import Footer from "../Footer";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import { Redirect, withRouter } from "react-router";
import { connect } from "react-redux";
import { getPromoSlides } from "../../../services/promoSlider/actions";
import { getRestaurantCategorySlides } from "../../../services/restaurantCategorySlider/actions";
import { 
	getBrandDeliveryRestaurants,
	getBrandSelfpickupRestaurants,
	getRestaurantsCategories 
} from "../../../services/restaurant/actions";
import { 
	getRestaurantInfo,
	getRestaurantItems,
	getRestaurantInfoForLoggedInUser 
} from "../../../services/items/actions";
import { brandPush } from "../../../helpers/brandNavigation";
import { getBrandPrefix, brandRoute } from "../../../helpers/restaurantSlugDetector";
import { getBrandLocations } from "../../../services/singlestore/actions";
import ItemList from "../Items/ItemList";
import RestaurantInfo from "../Items/RestaurantInfo";
import FloatCart from "../FloatCart";

import messaging from "../../../init-fcm";
import { saveNotificationToken } from "../../../services/notification/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { getUserNotifications } from "../../../services/alert/actions";
import { resetInfo, resetItems, resetBackup } from "../../../services/items/actions";
import { getRecommendedItems } from "../../../services/recommendedItems/actions";
import { updateCart } from "../../../services/total/actions";
import { GET_RESTAURANTS_SLIDES_URL } from "../../../configs";
import Axios from "axios";
import RecommendedItems from "../Items/ItemList/RecommendedItems";

import { Link } from "react-router-dom";
import DelayLink from "../../helpers/delayLink";
import ContentLoader from "react-content-loader";

import Dialog from "@material-ui/core/Dialog";
import GpsSelector from "../Location/PopularPlaces/GpsSelector";
import Ink from "react-ink";
import PromoSlider from "../Home/PromoSlider";
import RestaurantSlider from "../RestaurantSlider";
import SelectAnotherLocation from "../SelectAnotherLocation";
import BrandRestaurantSelector from "../BrandRestaurantSelector";
import { GET_RESTAURANT_SLIDERS_URL } from "../../../configs";
import SingleStore from "./SingleStore";
import MeatCategories from "../Items/MeatCategories";

class MainPage extends Component {
    static contextTypes = {
		router: () => null,
	};

	state = {
		loadingBrandLocations: false, // Track if we're already loading brand locations to prevent duplicate calls
		loading: true,
		total: 0,
		userPreferredSelectionDelivery: true,
		userPreferredSelectionSelfPickup: false,
		nearestRestaurant: null,
		restaurantInfo: null,
		is_active: 1,
		restaurantSliders: [],
		slidersLoading: true,
		allBrandRestaurants: [], // Store all available brand restaurants
	};

    async componentDidMount() {
        const { user, singlestoreRestaurant } = this.props;
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        
        // Store current location for change detection
        this.currentLocation = JSON.stringify(userSetAddress);
        
        // Add event listener for location changes
        window.addEventListener('storage', this.handleLocationChange);
        window.addEventListener('locationChanged', this.handleLocationChange);
        
        // Reset items
        this.props.resetItems();
		this.props.resetInfo();
		this.props.resetBackup();
		
        // Load promo slides
        this.props.getPromoSlides(userSetAddress.lat, userSetAddress.lng);
		
		// Load restaurant category slides
		this.props.getRestaurantCategorySlides(userSetAddress.lat, userSetAddress.lng);
		
		// If we already have restaurant from store-config, use it directly
		// This restaurant is already the NEAREST restaurant from the brand (calculated by backend API)
		// The store-config API calculates distance from user's coordinates and returns the nearest one
		if (singlestoreRestaurant && singlestoreRestaurant.id) {
			console.log('🏪 MainPage: Using NEAREST restaurant from store-config (brand):', {
				id: singlestoreRestaurant.id,
				name: singlestoreRestaurant.name,
				address: singlestoreRestaurant.address,
				distance: singlestoreRestaurant.distance || 'N/A'
			});
			
			// Get brand locations if available, or we'll load them
			const { brandLocations, hasMultipleLocations } = this.props;
			
			this.setState({ 
				restaurantInfo: singlestoreRestaurant,
				nearestRestaurant: singlestoreRestaurant, // This is the nearest restaurant from the brand
				is_active: singlestoreRestaurant.is_active,
				loading: false,
				// If we have brandLocations from API, use them; otherwise loadBrandRestaurants will set allBrandRestaurants
				allBrandRestaurants: brandLocations && brandLocations.length > 0 ? brandLocations : this.state.allBrandRestaurants,
				total: brandLocations && brandLocations.length > 0 ? brandLocations.length : this.state.total
			});
			
			// Load restaurant data (items, etc.)
			this.loadRestaurantData(singlestoreRestaurant.slug);
			
			// Load brand restaurants for the selector (to show all locations)
			// This will call getBrandLocations if hasMultipleLocations is true
			// Don't call getBrandLocations separately here to avoid duplicate calls
			this.loadBrandRestaurants();
		} else {
			// Load restaurants and categories for brand
			// This will also try to find the nearest one from the list
			this.loadBrandRestaurants();
		}
		
		this.props.getRestaurantsCategories();

        if (user.success) {
            this.props.getUserNotifications(user.data.id, user.data.auth_token);
        }

        if (user.success) {
			if (localStorage.getItem("enablePushNotification") === "true") {
				if (firebase.messaging.isSupported()) {
					let handler = this.props.saveNotificationToken;
					messaging
                    .requestPermission()
                    .then(async function() {
                        const push_token = await messaging.getToken();
                        handler(push_token, user.data.id, user.data.auth_token);
                    })
                    .catch(function(err) {
                        console.log("Unable to get permission to notify.", err);
                    });
				}
			}
		}
		
		// Check user preference
		if (localStorage.getItem("userPreferredSelection") === "SELFPICKUP") {
			this.setState({
				userPreferredSelectionSelfPickup: true,
				userPreferredSelectionDelivery: false,
			});
		}
    }
	
	loadBrandRestaurants = () => {
		const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
		const brandSlug = localStorage.getItem('brandUniqueId') || getBrandPrefix();
		
		console.log("🏪 MainPage: Loading brand restaurants for:", brandSlug, "hasMultipleLocations:", this.props.hasMultipleLocations, "brandLocations:", this.props.brandLocations && this.props.brandLocations.length);
		
		this.setState({ loading: true });
		
		if (brandSlug) {
			// ALWAYS use getBrandLocations if hasMultipleLocations is true
			// This API returns ALL locations for the brand, not filtered by delivery areas
			// But only call if we don't already have locations loaded
			if (this.props.hasMultipleLocations) {
				// If we already have brandLocations from Redux, use them instead of calling API again
				if (this.props.brandLocations && this.props.brandLocations.length > 0) {
					console.log('🏪 MainPage: Using existing brandLocations from Redux:', this.props.brandLocations.length);
					const sortedLocations = [...this.props.brandLocations].sort((a, b) => {
						const distA = (a.distance !== null && a.distance !== undefined) ? parseFloat(a.distance) : Number.POSITIVE_INFINITY;
						const distB = (b.distance !== null && b.distance !== undefined) ? parseFloat(b.distance) : Number.POSITIVE_INFINITY;
						return distA - distB;
					});
					this.setState({ 
						allBrandRestaurants: sortedLocations,
						total: sortedLocations.length,
						loading: false
					});
					return;
				}
				
				// Only call API if we're not already loading
				if (this.state.loadingBrandLocations) {
					console.log('🏪 MainPage: Already loading brand locations, skipping duplicate call');
					return;
				}
				
				console.log('🏪 MainPage: Brand has multiple locations, calling getBrandLocations API to get ALL stores');
				this.setState({ loadingBrandLocations: true });
				
				this.props.getBrandLocations(brandSlug, userSetAddress.lat, userSetAddress.lng)
					.then((result) => {
						console.log('🏪 MainPage: getBrandLocations API result:', result);
						
						// The result contains {success, brand, locations}
						const locations = result && result.locations ? result.locations : [];
						
						if (locations && locations.length > 0) {
							console.log('🏪 MainPage: Loaded ALL brand locations:', locations.length, locations.map(l => ({ id: l.id, name: l.name, distance: l.distance })));
							
							// Sort by distance (nearest first) - API should already sort, but ensure it
							const sortedLocations = [...locations].sort((a, b) => {
								const distA = (a.distance !== null && a.distance !== undefined) ? parseFloat(a.distance) : Number.POSITIVE_INFINITY;
								const distB = (b.distance !== null && b.distance !== undefined) ? parseFloat(b.distance) : Number.POSITIVE_INFINITY;
								return distA - distB;
							});
							
							console.log('🏪 MainPage: Sorted locations by distance (nearest first):', sortedLocations.map(l => ({ id: l.id, name: l.name, distance: l.distance })));
							
							this.setState({ 
								allBrandRestaurants: sortedLocations,
								total: sortedLocations.length,
								loading: false
							});
							
							// Don't override the restaurant from store-config, just update the list for selector
							return;
						} else {
							console.warn('🏪 MainPage: No locations from getBrandLocations API');
							this.setState({ loading: false });
						}
					})
					.catch((error) => {
						console.error('🏪 MainPage: Error loading brand locations:', error);
						this.setState({ loading: false, loadingBrandLocations: false });
					})
					.finally(() => {
						this.setState({ loadingBrandLocations: false });
					});
				
				// IMPORTANT: Return early to prevent calling fallback APIs
				// getBrandLocations is the correct API for multi-location brands
				return;
			}
			
			// Use brand-scoped API to get restaurants (fallback or if not multi-location)
			const preferredSelection = localStorage.getItem("userPreferredSelection");
			
			const restaurantPromise = preferredSelection === "SELFPICKUP"
				? this.props.getBrandSelfpickupRestaurants(userSetAddress.lat, userSetAddress.lng)
				: this.props.getBrandDeliveryRestaurants(userSetAddress.lat, userSetAddress.lng);
			
		restaurantPromise.then((result) => {
			console.log("🏪 MainPage: Brand restaurants result:", result);
			
			// The payload contains {success, restaurants, brand} or just array of restaurants
			const restaurants = result && result.payload 
				? (result.payload.restaurants || result.payload || [])
				: (Array.isArray(result) ? result : []);
			
			console.log("🏪 MainPage: Extracted restaurants:", restaurants.length, restaurants);
			
			if (restaurants && restaurants.length > 0) {
				// Sort by distance (nearest first)
				const sortedRestaurants = [...restaurants].sort((a, b) => {
					const distA = (a.distance !== null && a.distance !== undefined) ? parseFloat(a.distance) : Number.POSITIVE_INFINITY;
					const distB = (b.distance !== null && b.distance !== undefined) ? parseFloat(b.distance) : Number.POSITIVE_INFINITY;
					return distA - distB;
				});
				
				// Store all restaurants for selector
				console.log('🏪 MainPage: Loaded brand restaurants (sorted by distance, nearest first):', sortedRestaurants.length, sortedRestaurants.map(r => ({ id: r.id, name: r.name, distance: r.distance })));
				this.setState({ 
					allBrandRestaurants: sortedRestaurants,
					total: sortedRestaurants.length 
				});
				
			// Priority for selecting restaurant:
			// 1. User's manual selection (from BrandRestaurantSelector)
			// 2. Restaurant from store-config (already determined as nearest)
			// 3. First restaurant from the list (fallback)
			
			let selectedRestaurant = null;
			
			// Check if user has manually selected a restaurant
			const storedRestaurantId = localStorage.getItem('selectedBrandRestaurantId');
			if (storedRestaurantId) {
				selectedRestaurant = restaurants.find(r => r.id == storedRestaurantId);
				// console.log("Using manually selected restaurant:", selectedRestaurant);
			}
			
			// If no manual selection, use the restaurant determined by store-config API
			if (!selectedRestaurant) {
				const configRestaurantSlug = localStorage.getItem('restaurantSlug');
				if (configRestaurantSlug) {
					selectedRestaurant = restaurants.find(r => r.slug === configRestaurantSlug);
					// console.log("Using store-config restaurant (nearest):", selectedRestaurant);
				}
			}
			
			// Fallback: use first restaurant
			if (!selectedRestaurant) {
				selectedRestaurant = restaurants[0];
				// console.log("Using fallback (first) restaurant:", selectedRestaurant);
			}
			
			// console.log("Final selected restaurant:", selectedRestaurant);
				
				this.setState({ 
					nearestRestaurant: selectedRestaurant,
				});
				
				// Fetch restaurant info and items
				this.loadRestaurantData(selectedRestaurant.slug);
			} else {
				// console.error("No restaurants found in result");
				this.setState({ loading: false, total: 0 });
			}
		}).catch((error) => {
			// console.error("Error loading brand restaurants:", error);
			this.setState({ loading: false, total: 0 });
		});
		} else {
			// console.error("No brand slug found");
			this.setState({ loading: false });
		}
	};
	
	loadRestaurantData = (restaurantSlug) => {
		const { user } = this.props;
		
		// console.log("Loading restaurant data for:", restaurantSlug);
		
		// Get restaurant info
		const infoPromise = user.success
			? this.props.getRestaurantInfoForLoggedInUser(restaurantSlug)
			: this.props.getRestaurantInfo(restaurantSlug);
		
		if (infoPromise) {
			infoPromise.then((response) => {
				// console.log("Restaurant info response:", response);
				
				if (response && response.payload) {
					// console.log("Setting restaurant info:", response.payload);
					
					this.setState({ 
						restaurantInfo: response.payload,
						is_active: response.payload.is_active,
						loading: false
					});
					
					// Set delivery type
					if (response.payload.delivery_type === 1) {
						localStorage.setItem("userSelected", "DELIVERY");
					}
					if (response.payload.delivery_type === 2) {
						localStorage.setItem("userSelected", "SELFPICKUP");
					}
					
					// Get menu items
					this.props.getRestaurantItems(restaurantSlug);
					
					// Fetch recommended items
					if (response.payload.id) {
						this.props.getRecommendedItems(response.payload.id, 10);
					}
					
					// Load restaurant sliders
					this.loadRestaurantSliders(restaurantSlug);
				} else {
					console.error("No restaurant info in response");
					this.setState({ loading: false });
				}
			}).catch((error) => {
				console.error("Error loading restaurant data:", error);
				this.setState({ loading: false });
			});
		} else {
			console.error("No info promise returned");
			this.setState({ loading: false });
		}
	};
	
	loadRestaurantSliders = (restaurantSlug) => {
		this.setState({ slidersLoading: true });
		
		Axios.get(`${GET_RESTAURANT_SLIDERS_URL}/${restaurantSlug}`)
			.then((response) => {
				// console.log("Restaurant sliders response:", response.data);
				
				if (response.data.success && response.data.sliders) {
					// Get sliders for position 1 (top of page)
					const topSliders = response.data.sliders.filter(slider => slider.position_id === 1);
					
					if (topSliders.length > 0 && topSliders[0].slides) {
						this.setState({ 
							restaurantSliders: topSliders[0].slides,
							slidersLoading: false 
						});
					} else {
						this.setState({ slidersLoading: false });
					}
				} else {
					this.setState({ slidersLoading: false });
				}
			})
			.catch((error) => {
				console.error("Error loading restaurant sliders:", error);
				this.setState({ slidersLoading: false });
			});
	};
	
	filterDelivery = () => {
		this.setState({
			userPreferredSelectionDelivery: true,
			userPreferredSelectionSelfPickup: false,
		});
		localStorage.setItem("userPreferredSelection", "DELIVERY");
		this.loadBrandRestaurants();
	};

	filterSelfPickup = () => {
		this.setState({
			userPreferredSelectionSelfPickup: true,
			userPreferredSelectionDelivery: false,
		});
		localStorage.setItem("userPreferredSelection", "SELFPICKUP");
		this.loadBrandRestaurants();
	};
	
	handleRestaurantSelection = (restaurant) => {
		console.log("🏪 User manually selected restaurant:", restaurant);
		
		// Store selection in localStorage
		localStorage.setItem('selectedBrandRestaurantId', restaurant.id);
		
		// Store dynamic WhatsApp number from selected store
		if (restaurant.phone) {
			const whatsappPhone = restaurant.phone.replace(/\D/g, '');
			if (whatsappPhone.length >= 10) {
				localStorage.setItem("whatsappContactNumber", whatsappPhone);
				localStorage.setItem("supportContactNumber", whatsappPhone);
				console.log("📱 WhatsApp Number Updated for Selected Store:", whatsappPhone, restaurant.name);
			}
		}
		
		// // Store dynamic location (latitude/longitude) from selected store
		// if (restaurant.latitude && restaurant.longitude) {
		// 	const selectedStoreLocation = {
		// 		latitude: parseFloat(restaurant.latitude),
		// 		longitude: parseFloat(restaurant.longitude),
		// 		address: restaurant.address || restaurant.name || "Selected Store Location",
		// 		name: restaurant.name || "Selected Store",
		// 		city: restaurant.city || null,
		// 		state: restaurant.state || null,
		// 		pincode: restaurant.pincode || null,
		// 		landmark: restaurant.landmark || null
		// 	};
		// 	localStorage.setItem("storeDefaultLocation", JSON.stringify(selectedStoreLocation));
			
		// 	// Update userSetAddress with selected store location
		// 	const userSetAddress = {
		// 		lat: selectedStoreLocation.latitude,
		// 		lng: selectedStoreLocation.longitude,
		// 		address: selectedStoreLocation.address,
		// 		house: null,
		// 		tag: null,
		// 		city: selectedStoreLocation.city,
		// 		state: selectedStoreLocation.state,
		// 		businessLocation: true,
		// 	};
		// 	localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
		// 	localStorage.setItem("userAlreadySelectedLocation", "true");
			
		// 	console.log("📍 Location Updated for Selected Store:", {
		// 		name: restaurant.name,
		// 		latitude: selectedStoreLocation.latitude,
		// 		longitude: selectedStoreLocation.longitude,
		// 		address: selectedStoreLocation.address
		// 	});
		// }
		
		// // Store customer details for selected store
		// const customerDetails = {
		// 	storeName: restaurant.name,
		// 	storeAddress: restaurant.address || null,
		// 	storeCity: restaurant.city || null,
		// 	storeState: restaurant.state || null,
		// 	storePincode: restaurant.pincode || null,
		// 	storePhone: restaurant.phone || null,
		// 	latitude: restaurant.latitude ? parseFloat(restaurant.latitude) : null,
		// 	longitude: restaurant.longitude ? parseFloat(restaurant.longitude) : null,
		// 	landmark: restaurant.landmark || null,
		// };
		// localStorage.setItem("storeCustomerDetails", JSON.stringify(customerDetails));
		
		// Update state and reload restaurant data
		this.setState({ 
			nearestRestaurant: restaurant,
			loading: true,
			restaurantInfo: null, // Clear old restaurant info
			restaurantSliders: [], // Clear old sliders
			slidersLoading: true, // Show loading for sliders
		});
		
		// Reload promo slides for new restaurant location
		if (restaurant.latitude && restaurant.longitude) {
			// Use restaurant's coordinates for promo slides
			this.props.getPromoSlides(restaurant.latitude, restaurant.longitude);
			this.props.getRestaurantCategorySlides(restaurant.latitude, restaurant.longitude);
		} else {
			const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
			if (userSetAddress) {
				// Fallback to user's coordinates
				this.props.getPromoSlides(userSetAddress.lat, userSetAddress.lng);
				this.props.getRestaurantCategorySlides(userSetAddress.lat, userSetAddress.lng);
			}
		}
		
		// Load new restaurant's data
		this.loadRestaurantData(restaurant.slug);
		
		// Dispatch location change event to notify other components
		window.dispatchEvent(new Event('locationChanged'));
	};
	
	changeRouteToRestaurantsCategories = (categories) => {
		if (categories.categories_ids) {
			const saveCategorySelectOptions = new Promise((resolve) => {
				localStorage.setItem("categorySelectOptions", JSON.stringify(categories.categories_ids));
				resolve("categorySelectOptions Saved");
			});
			saveCategorySelectOptions.then(() => {
				brandPush(this.props.history, "/categories/stores");
			});
		}
	};

    componentWillUnmount() {
        // Clean up event listeners
        window.removeEventListener('storage', this.handleLocationChange);
        window.removeEventListener('locationChanged', this.handleLocationChange);
    }

    handleLocationChange = () => {
        const currentLocationString = localStorage.getItem("userSetAddress");
        
        if (currentLocationString && this.currentLocation !== currentLocationString) {
            console.log("🌍 Geo Location changed! Reloading nearest restaurant...");
            
            // Parse old and new locations
            const oldLocation = this.currentLocation ? JSON.parse(this.currentLocation) : null;
            const newLocation = JSON.parse(currentLocationString);
            
            // Check if actual coordinates changed (not just restaurant selection)
            const coordsChanged = !oldLocation || 
                                  oldLocation.lat !== newLocation.lat || 
                                  oldLocation.lng !== newLocation.lng;
            
            if (coordsChanged) {
                console.log("📍 Coordinates changed - clearing manual selection...");
                
                // Clear selected restaurant from localStorage to force finding nearest
                localStorage.removeItem('selectedBrandRestaurantId');
                
                // Reload promo slides with new coordinates
                const newLocation = JSON.parse(currentLocationString);
                this.props.getPromoSlides(newLocation.lat, newLocation.lng);
                this.props.getRestaurantCategorySlides(newLocation.lat, newLocation.lng);
                
                // Show loading state
                this.setState({ loading: true });
                
                // Don't reload immediately - wait for SingleStoreRouter to update store-config
                // componentDidUpdate will trigger reload when singlestoreRestaurant changes
                console.log("⏳ Waiting for store-config to update with nearest restaurant...");
                
                // Update stored location
                this.currentLocation = currentLocationString;
            } else {
                console.log("ℹ️ Location object updated but coordinates same - no reload needed");
                this.currentLocation = currentLocationString;
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {
        // Only load brand locations if:
        // 1. hasMultipleLocations is true
        // 2. brandLocations is empty (not loaded yet)
        // 3. We haven't already triggered a load (check if loading state or if locations are being fetched)
        // 4. hasMultipleLocations just became true (to avoid calling on every update)
        if (this.props.hasMultipleLocations && 
            (!this.props.brandLocations || this.props.brandLocations.length === 0) &&
            (!prevProps.hasMultipleLocations || prevProps.brandLocations !== this.props.brandLocations)) {
            const brandSlug = localStorage.getItem('brandUniqueId') || getBrandPrefix();
            const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress") || '{}');
            
            // Only call if we have valid data and haven't already called it
            if (brandSlug && userSetAddress && userSetAddress.lat && userSetAddress.lng && 
                !this.state.loadingBrandLocations) {
                console.log('🏪 MainPage: hasMultipleLocations is true but locations empty, loading brand locations...', brandSlug);
                this.setState({ loadingBrandLocations: true });
                this.props.getBrandLocations(brandSlug, userSetAddress.lat, userSetAddress.lng)
                    .finally(() => {
                        this.setState({ loadingBrandLocations: false });
                    });
            }
        }
        
        // Update allBrandRestaurants and total when brandLocations become available
        if (this.props.brandLocations && 
            this.props.brandLocations.length > 0 && 
            (prevProps.brandLocations !== this.props.brandLocations || 
             !this.state.allBrandRestaurants || 
             this.state.allBrandRestaurants.length === 0)) {
            console.log('🏪 MainPage: Brand locations available, updating state:', this.props.brandLocations.length, this.props.brandLocations);
            this.setState({
                allBrandRestaurants: this.props.brandLocations,
                total: this.props.brandLocations.length
            });
        }
        
        // Detect when store-config has been updated with new nearest restaurant
        // The store-config API calculates the nearest restaurant from the brand based on coordinates
        if (this.props.singlestoreRestaurant && 
            prevProps.singlestoreRestaurant && 
            this.props.singlestoreRestaurant.id !== prevProps.singlestoreRestaurant.id) {
            console.log("🏪 Store-config updated with NEW NEAREST restaurant from brand:", {
                id: this.props.singlestoreRestaurant.id,
                name: this.props.singlestoreRestaurant.name,
                address: this.props.singlestoreRestaurant.address,
                distance: this.props.singlestoreRestaurant.distance || 'N/A',
                hasMultipleLocations: this.props.hasMultipleLocations
            });
            
            // Update current location reference
            const currentLocationString = localStorage.getItem("userSetAddress");
            if (currentLocationString) {
                this.currentLocation = currentLocationString;
            }
            
            // Use the new nearest restaurant from store-config directly
            const newRestaurant = this.props.singlestoreRestaurant;
            this.setState({ 
                restaurantInfo: newRestaurant,
                nearestRestaurant: newRestaurant, // Nearest restaurant from the brand
                is_active: newRestaurant.is_active,
                loading: false,
                // Update restaurants list if brandLocations available
                allBrandRestaurants: this.props.brandLocations && this.props.brandLocations.length > 0 
                    ? this.props.brandLocations 
                    : this.state.allBrandRestaurants,
                total: this.props.brandLocations && this.props.brandLocations.length > 0 
                    ? this.props.brandLocations.length 
                    : this.state.total
            });
            
            // Load restaurant data (items, etc.)
            this.loadRestaurantData(newRestaurant.slug);
            
            // Reload brand restaurants list for the selector (to show all locations)
            // This will call getBrandLocations if hasMultipleLocations is true
            // Don't call getBrandLocations separately here to avoid duplicate calls
            this.loadBrandRestaurants();
        }
        
        // Also handle case where singlestoreRestaurant appears for the first time
        // This is the nearest restaurant from the brand (calculated by backend)
        if (this.props.singlestoreRestaurant && 
            !prevProps.singlestoreRestaurant && 
            this.props.singlestoreRestaurant.id) {
            console.log("🏪 MainPage: NEAREST restaurant from brand appeared:", {
                id: this.props.singlestoreRestaurant.id,
                name: this.props.singlestoreRestaurant.name,
                address: this.props.singlestoreRestaurant.address,
                distance: this.props.singlestoreRestaurant.distance || 'N/A',
                hasMultipleLocations: this.props.hasMultipleLocations
            });
            
            const restaurant = this.props.singlestoreRestaurant;
            this.setState({ 
                restaurantInfo: restaurant,
                nearestRestaurant: restaurant, // Nearest restaurant from the brand
                is_active: restaurant.is_active,
                loading: false,
                // Update restaurants list if brandLocations available
                allBrandRestaurants: this.props.brandLocations && this.props.brandLocations.length > 0 
                    ? this.props.brandLocations 
                    : this.state.allBrandRestaurants,
                total: this.props.brandLocations && this.props.brandLocations.length > 0 
                    ? this.props.brandLocations.length 
                    : this.state.total
            });
            
            // Load restaurant data
            this.loadRestaurantData(restaurant.slug);
            
            // Load brand restaurants for the selector (to show all locations)
            // This will call getBrandLocations if hasMultipleLocations is true
            // Don't call getBrandLocations separately here to avoid duplicate calls
            this.loadBrandRestaurants();
        }
        
        // Also check on component update (when coming back from other pages)
        const currentLocationString = localStorage.getItem("userSetAddress");
        
        if (currentLocationString && this.currentLocation !== currentLocationString) {
            console.log("🔄 Component updated - Location changed! Reloading nearest restaurant...");
            this.handleLocationChange();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.languages !== nextProps.languages) {
            if (localStorage.getItem("userPreferedLanguage")) {
                this.props.getSingleLanguageData(localStorage.getItem("userPreferedLanguage"));
            } else {
                if (nextProps.languages.length) {
                    // console.log("Fetching Translation Data...");
                    const id = nextProps.languages.filter((lang) => lang.is_default === 1)[0].id;
                    this.props.getSingleLanguageData(id);
                }
            }
        }
    }

    render() {
        if (localStorage.getItem("hideDesktopView") !== "true" &&  window.innerWidth > 768) {
            return <Redirect to={brandRoute("/")} />;
        }
        const { history, user, promo_slides, restaurants, restaurantCategorySlides } = this.props;

        return (
            <React.Fragment>
                <Meta
					seotitle={localStorage.getItem("seoMetaTitle")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>
				
				{/* Multi-Location Banner */}
				<SelectAnotherLocation />
				
                <div className="height-100-percent mb-100">
                    <div className="custom-bg">
                        <Nav
							logo={true}
							active_nearme={true}
							disable_back_button={true}
							history={history}
							loggedin={user.success}
						/>
					
						{/* Mock Search Bar */}
						{localStorage.getItem("mockSearchOnHomepage") === "true" && (
							<div className="bg-white custom-bg" style={{ position:"sticky", top:"52px", zIndex:"1", paddingBottom:"2px" }}>
								<Link to={brandRoute("/explore")}>
									<div className="mock-search-block-new pb-5">
										<div className="d-flex justify-content-between mock-search--block-new-inner">
											<div className="mock-search-left">
												<img src="/assets/img/search.svg" alt="search" />
											</div>
											<div>
												<span>{localStorage.getItem("mockSearchPlaceholder")}</span>
											</div>
											<div className="mock-search-right">
												<img src="/assets/img/mic.svg" alt="search" />
											</div>
										</div>
									</div>
								</Link>
							</div>
						)}
                        
                        {/* Restaurant Slider - Fixed 984x504 size */}
                        {!this.state.slidersLoading && this.state.restaurantSliders && this.state.restaurantSliders.length > 0 && (
                            <div className="" style={{ paddingBottom:"10px" }}>
                                <RestaurantSlider
                                    key={this.state.nearestRestaurant ? this.state.nearestRestaurant.id : 'default'}
                                    slides={this.state.restaurantSliders}
                                    size={504}
                                />
                            </div>
                        )}
						
				{/* Delivery/Self-Pickup Toggle with Restaurant Selector */}
				{localStorage.getItem("enSPU") === "true" && (
					<div className="bg-light px-15 py-3 sticky-top" style={{top: localStorage.getItem("mockSearchOnHomepage") === "true" ? "90px" : "52px"}}>
						<div className="d-flex justify-content-between align-items-center">
							{/* Show Restaurant Selector if multiple restaurants, otherwise empty */}
							{/* Use hasMultipleLocations from store-config API, or check total/allBrandRestaurants */}
							{(this.props.hasMultipleLocations || this.state.total > 1 || (this.state.allBrandRestaurants && this.state.allBrandRestaurants.length > 1)) ? (
								<BrandRestaurantSelector
									restaurants={this.state.allBrandRestaurants && this.state.allBrandRestaurants.length > 0 
										? this.state.allBrandRestaurants 
										: (this.props.brandLocations && this.props.brandLocations.length > 0 
											? this.props.brandLocations 
											: [])}
									currentRestaurant={this.state.nearestRestaurant}
									onRestaurantSelect={this.handleRestaurantSelection}
								/>
							) : (
								<div></div>
							)}
							
							<div className="d-flex btn-group btn-preference-group">
								<button
									onClick={this.filterDelivery}
									className={`btn btn-preference ${this.state.userPreferredSelectionDelivery ? "user-preferred" : ""}`}
								>
									{localStorage.getItem("deliveryTypeDelivery")}
								</button>
								<button
									onClick={this.filterSelfPickup}
									className={`btn btn-preference ${this.state.userPreferredSelectionSelfPickup ? "user-preferred" : ""}`}
								>
									{localStorage.getItem("deliveryTypeSelfPickup")}
								</button>
							</div>
						</div>
					</div>
				)}
						
                        {/* Restaurant Info - Show nearest restaurant */}
                        {!this.state.loading && this.state.restaurantInfo && (
                            <React.Fragment>
                                <SingleStore 
                                    restaurant={this.state.restaurantInfo}
                                    loading={this.state.loading}
                                    history={this.props.history}
                                />
                                
                                <MeatCategories
                                    restaurant_id={this.state.restaurantInfo.id}
                                    restaurant_slug={this.state.restaurantInfo.slug}
                                />

								{/* Recommended Items Section */}
                                {this.props.recommendedItems && this.props.recommendedItems.items && Object.keys(this.props.recommendedItems.items).length > 0 && (
                                    <div className="recommended-items-section" style={{ backgroundColor: "#fff", padding: "15px 10px", marginBottom: "10px" }}>
                                        <div className="section-header" style={{ padding: "0 10px 10px 10px" }}>
                                            <h3 style={{ fontSize: "18px", fontWeight: "600", margin: "0", color: "#282c3f" }}>
                                                Recommended for You
                                            </h3>
                                        </div>
                                        <div className="recommended-items-slider" style={{ display: "flex", overflowX: "auto", gap: "12px", padding: "0 5px", scrollBehavior: "smooth" }}>
                                            {Object.keys(this.props.recommendedItems.items).map((categoryName) => 
                                                this.props.recommendedItems.items[categoryName].map((item) => (
                                                    <div key={item.id} style={{ minWidth: "150px", flex: "0 0 auto" }}>
                                                    <RecommendedItems 
                                                        product={item}
                                                        restaurant={this.state.restaurantInfo}
                                                        update={() => this.forceUpdate()}
                                                        updateCart={this.props.updateCart}
                                                    />
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}

                            </React.Fragment>
                        )}
                        {/* Loading State */}
                        {this.state.loading && (
                            <div className="bg-white">
                                <ContentLoader
                                    height={378}
                                    width={400}
                                    speed={1.2}
                                    primaryColor="#f3f3f3"
                                    secondaryColor="#ecebeb"
                                >
                                    <rect x="20" y="20" rx="4" ry="4" width="80" height="78" />
                                    <rect x="144" y="30" rx="0" ry="0" width="115" height="18" />
                                    <rect x="144" y="60" rx="0" ry="0" width="165" height="16" />

                                    <rect x="20" y="145" rx="4" ry="4" width="80" height="78" />
                                    <rect x="144" y="155" rx="0" ry="0" width="115" height="18" />
                                    <rect x="144" y="185" rx="0" ry="0" width="165" height="16" />

                                    <rect x="20" y="270" rx="4" ry="4" width="80" height="78" />
                                    <rect x="144" y="280" rx="0" ry="0" width="115" height="18" />
                                    <rect x="144" y="310" rx="0" ry="0" width="165" height="16" />
                                </ContentLoader>
                            </div>
                        )}
                        
                        {/* No Restaurant Found */}
                        {!this.state.loading && !this.state.restaurantInfo && (
                            <div className="bg-white">
                                <div className="text-center py-5">
                                    <i className="si si-home" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                                    <p className="text-muted mt-3">{localStorage.getItem("noRestaurantMessage") || "No restaurants available"}</p>
                                </div>
                            </div>
                        )}
			
                    </div>
                </div>
				
				{/* Floating Cart - Always render to handle cart updates */}
				<FloatCart isMainPage={true} />
				
                <Footer active_home={true} />
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => ({
    promo_slides: state.promo_slides.promo_slides,
	restaurantCategorySlides: state.restaurant_category_slides.restaurant_category_slides,
	restaurants: state.restaurant.restaurants,
	restaurantsCategories: state.restaurant.restaurantsCategories,
	items: state.items.items,
	cartProducts: state.cart.products,
    user: state.user.user,
    locations: state.locations.locations,
    languages: state.languages.languages,
    language: state.languages.language,
    popular_locations: state.popular_locations.popular_locations,
    singlestoreRestaurant: state.singlestore.currentRestaurant, // From store-config
    hasMultipleLocations: state.singlestore.hasMultipleLocations, // From store-config
    brandLocations: state.singlestore.brandLocations, // All brand locations from API
    recommendedItems: state.recommendedItems,
});

export default withRouter(connect(
    mapStateToProps,
    {
        getPromoSlides,
		getRestaurantCategorySlides,
		getBrandDeliveryRestaurants,
		getBrandSelfpickupRestaurants,
		getRestaurantsCategories,
		getRestaurantInfo,
		getRestaurantItems,
		getRestaurantInfoForLoggedInUser,
        saveNotificationToken,
        getSingleLanguageData,
        getUserNotifications,
        resetInfo,
        resetItems,
        resetBackup,
        getRecommendedItems,
        updateCart,
        getBrandLocations, // Get all brand locations for multi-location brands
    }
)(MainPage));
